import { QuestEditorApi } from "@worldwidewebb/client-quests";
import { axiosInstance, buildQuestClientBasePath } from "..";

const questEditorApi = new QuestEditorApi(undefined, buildQuestClientBasePath(), axiosInstance);

export async function getDungeonIds(): Promise<string[]> {
  try {
    const { data: dungeonIds } = await questEditorApi.getDungeonIds();

    if (!dungeonIds) {
      return [];
    }

    return dungeonIds.sort((a, b) => a.localeCompare(b));
  } catch (error) {
    console.error(error);
    throw error;
  }
}
